export const nascarDataStateStore = {
  state: {
    testdata: null,
    allDrivers: {},
    driverPoints: [],
    raceMetadata: null,
    lapsRemaining: null,
    entries: [],
    results: [],
    allDriverColors: [],
    currentStage: null,
    currentFlag: null,
    currentLeader: null,
    focusedVehicle: null,
    staticResultsLookup: null,
    mapOpen: true,
    mapMode: 0, //0 top 5, 1 favorite driver
    topFiveTelemetry: [],
    favoriteDriver: {
      telemetry: null,
      data: null,
      id: null,
      boundListener: null
    },
    topDriver: {
      telemetry: null,
      data: null,
      id: null,
      boundListener: null
    },
    currentToast: null,
    hasCommitFirstFavoriteDriver: false,
    isAppMinimized: false,
    loadingScreen: true
  },
  getters: {
    testdata: (state) => {
      return state.testdata;
    },
    allDrivers: (state) => {
      return state.allDrivers;
    },
    driverPoints: (state) => {
      return state.driverPoints;
    },
    raceMetadata: (state) => {
      return state.raceMetadata;
    },
    lapsRemaining: (state) => {
      return state.lapsRemaining;
    },
    entries: (state) => {
      return state.entries;
    },
    results: (state) => {
      return state.results;
    },
    allDriverColors: (state) => {
      return state.allDriverColors;
    },
    currentStage: (state) => {
      return state.currentStage;
    },
    currentFlag: (state) => {
      return state.currentFlag;
    },
    currentLeader: (state) => {
      return state.currentLeader;
    },
    focusedVehicle: (state) => {
      return state.focusedVehicle;
    },
    staticResultsLookup: (state) => {
      return state.staticResultsLookup;
    },
    mapOpen: (state) => {
      return state.mapOpen;
    },
    topFiveTelemetry: (state) => {
      return state.topFiveTelemetry;
    },
    favoriteDriver: (state) => {
      return state.favoriteDriver;
    },
    topDriver: (state) => {
      return state.topDriver;
    },
    mapMode: (state) => {
      return state.mapMode;
    },
    currentToast: (state) => {
      return state.currentToast;
    },
    hasCommitFirstFavoriteDriver: (state) => {
      return state.hasCommitFirstFavoriteDriver;
    },
    isAppMinimized: (state) => {
      return state.isAppMinimized;
    },
    loadingScreen: (state) => {
      return state.loadingScreen;
    },
  },
  mutations: {
    testdata(state, target) {
      state.testdata = target;
    },
    allDrivers(state, target) {
      state.allDrivers = target;
    },
    driverPoints(state, target) {
      state.driverPoints = target;
    },
    raceMetadata(state, target) {
      state.raceMetadata = target;
    },
    lapsRemaining(state, target) {
      state.lapsRemaining = target;
    },
    entries(state, target) {
      state.entries = target;
    },
    results(state, target) {
      state.results = target;
    },
    allDriverColors(state, target) {
      state.allDriverColors = target;
    },
    currentStage(state, target) {
      state.currentStage = target;
    },
    currentFlag(state, target) {
      state.currentFlag = target;
    },
    currentLeader(state, target) {
      state.currentLeader = target;
    },
    focusedVehicle(state, target) {
      state.focusedVehicle = target;
    },
    staticResultsLookup(state, target) {
      state.staticResultsLookup = target;
    },
    mapOpen(state, target) {
      state.mapOpen = target;
    },
    topFiveTelemetry(state, {telemetry, index}) {
      state.topFiveTelemetry[index] = telemetry;
    },
    favoriteDriverTelemetry(state, telemetry) {
      state.favoriteDriver.telemetry = telemetry;
    },
    favoriteDriverData(state, data) {
      state.favoriteDriver.data = data;
    },
    favoriteDriverID(state, id) {
      state.favoriteDriver.id = id;
    },
    favoriteDriverBoundListener(state, target) {
      state.favoriteDriver.boundListener = target;
    },
    topDriverTelemetry(state, telemetry) {
      state.topDriver.telemetry = telemetry;
    },
    topDriverData(state, data) {
      state.topDriver.data = data;
    },
    topDriverID(state, id) {
      state.topDriver.id = id;
    },
    topDriverBoundListener(state, target) {
      state.topDriver.boundListener = target;
    },
    mapMode(state, mapMode) {
      state.mapMode = mapMode;
    },
    currentToast(state, target) {
      state.currentToast = target
    },
    hasCommitFirstFavoriteDriver(state, target) {
      state.hasCommitFirstFavoriteDriver = target
    },
    isAppMinimized(state, target) {
      state.isAppMinimized = target
    },
    loadingScreen(state, target) {
      state.loadingScreen = target
    },
  }
};
